export default __webpack_public_path__ + "static/media/mamut_xl2.d7faca01.png";